import { DropDown } from '@aibees/shared/components';
import { Box } from '@mui/material';
import { memo, useState } from 'react';
import { useLabelColors } from './config';
import * as SX from './sx';
import type { ActionBulkSelectColorLabelProps as Props } from './types';
import { useColorOptions } from './use-color-options';

export const ActionBulkSelectColorLabel = memo(
  ({ className: _className, onChange }: Props) => {
    const options = useColorOptions();
    const colors = useLabelColors();
    const [value, setValue] = useState(() => colors.primary);

    const handleChange = (v: string) => {
      setValue(v);
      onChange?.(v);
    };

    return (
      <DropDown
        options={options}
        size="small"
        sx={SX.root}
        renderItem={(label, option) => (
          <Box
            sx={{
              width: 20,
              height: 20,
              borderRadius: '50%',
              bgcolor: option.value,
            }}
          />
        )}
        value={value}
        onChange={handleChange}
      />
    );
  }
);

ActionBulkSelectColorLabel.displayName = 'ActionBulkSelectColorLabel';
